module.exports={
    k:{name:'osho',promoted:false},
    r:{name:'hisha',promoted:false},
    rp:{name:'ryuo',promoted:true},
    b:{name:'kakugyo',promoted:false},
    bp:{name:'ryuma',promoted:true},
    g:{name:'kinsho',promoted:false},
    s:{name:'ginsho',promoted:false},
    sp:{name:'narigin',promoted:true},
    n:{name:'keima',promoted:false},
    np:{name:'narikei',promoted:true},
    l:{name:'kyosha',promoted:false},
    lp:{name:'narikyo',promoted:true},
    p:{name:'fuhyo',promoted:false},
    pp:{name:'tokin',promoted:true}
}